module.exports = __webpack_public_path__ + "daa4c6c22fb9047c8af53153cdf27c97.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/happy-25.png
// module id = 2153
// module chunks = 0